import { ref } from "vue";

export const useWaiter = <T>(fn: () => Promise<T>) => {
	const isLoading = ref(false);
	const hasFailed = ref(false);

	async function run() {
		try {
			isLoading.value = true;
			await fn();
		} catch (e) {
			hasFailed.value = true;
			isLoading.value = false;
			throw e;
		}

		hasFailed.value = false;
		isLoading.value = false;
	}

	return { run, isLoading, hasFailed };
};
